import React, { useState, useRef, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { QuizMainCard, QuizFirstCard } from "../../../component/molecule";
import { connect } from "react-redux";
import { Actions } from "../../../core/modules/Actions";
import moment from "moment";
import _ from "lodash";
import { IconButtonComponent } from "../../../component/atom";
import { QuestionStatus } from "../../../component/molecule/Cards";
import { navigateToQuizWithBreadcrumb } from "../../../core/Constant";

const QUIZ_FOCUS_EVENT = "quiz-focus-mode";

const getResumeAttempt = (quiz) => {
  let currentAttempts = quiz?.attempts
  if(quiz?.quiz_status?.length > 0){
     currentAttempts = quiz?.quiz_status?.[0]?.attempts;
  }
  const attempts = Number(currentAttempts);
  const maxAttempt = Number(quiz?.max_attempt);

  const hasValidMax = Number.isFinite(maxAttempt) && maxAttempt > 0;
  const hasValidAttempts = Number.isFinite(attempts) && attempts > 0;

  if (hasValidMax) {
    const isAttemptInvalid = !hasValidAttempts || attempts >= maxAttempt;
    return isAttemptInvalid ? Math.max(1, maxAttempt) : attempts;
  }
  return hasValidAttempts ? attempts : 1;
};

const getNewStartAttemptIndex = (quizData) => {
  let completedAttempts = Number(quizData?.attempts)
  if(quizData?.quiz_status?.[0]?.attempts){
    completedAttempts = Number(quizData?.quiz_status?.[0]?.attempts)
  }
  
  if (Number.isFinite(completedAttempts) && completedAttempts >= 0) {
    return completedAttempts;
  }
  return 0;
};

/** `remaining_time` comes into seconds and `duration` comes into minutes. */
const getQuizDurationMinutes = (startData, quizData) =>
  Number(startData?.duration ?? quizData?.duration) || 0;

const shouldUseRemainingTime = (remainingTime) =>
  remainingTime != null && Number(remainingTime) > 0;

const getDisplayDuration = (startData, quizData) => {
  if (shouldUseRemainingTime(startData?.remaining_time)) {
    return {
      value: Number(startData.remaining_time),
      fromRemainingTime: true,
    };
  }
  return {
    value: getQuizDurationMinutes(startData, quizData),
    fromRemainingTime: false,
  };
};

const QuizMainScreen = ({
  loadingAction,
  startData,
  stdstartQuiz,
  completeData,
  updateQuizState,
  isQuizStarted,
  stdquizComplted,
  questions,
  stdgetQuestions,
  stdStudentAnswer,
  studentAnswers,
  quizStateChange,

  quizDataNew = {},
  getAQuestionOfQuiz = () => {},
  currentQuestion = {},
  quizState = {},
  getStudentQuizStatus = () => {},
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [value, setValue] = React.useState(2);
  const [start, setStart] = useState(false);
  const [duration, setDuration] = useState();
  const [newDuration, setNewDuration] = useState();
  const [oldQuestions, setOldQuestions] = useState();
  const [quizData, setQuizData] = useState("");
  const timer = useRef(null);
  const pageStartTime = useRef(null);
  const apiTimeSpent = useRef(0);        
  const [stdData, setStdData] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [qData, setQData] = useState({});

  const [seconds, setNewSeconds] = useState(0);
  const [min, setMin] = useState(0);

  let time = 100;

  // Cleanup effect when leaving QuizMainScreen
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    if (start) {
      document.body.style.overflow = "hidden";
    }

    window.dispatchEvent(
      new CustomEvent(QUIZ_FOCUS_EVENT, { detail: { locked: Boolean(start) } })
    );

    return () => {
      document.body.style.overflow = prevOverflow;
      window.dispatchEvent(
        new CustomEvent(QUIZ_FOCUS_EVENT, { detail: { locked: false } })
      );
      typeof quizStateChange === "function" && quizStateChange(false);
      localStorage.removeItem("currentQuestion");
    };
  }, [start, quizStateChange]);

  useEffect(() => {
    pageStartTime.current = Date.now();
    const quizDataVal = location.state?.quizData;

    if (quizDataVal?.id) {
      setQuizData(quizDataVal);
      setQData({});
      getStudentQuizStatus(quizDataVal.id);

      try {
        const storedQ = sessionStorage.getItem(`currentQuestion_${quizDataVal.id}`);
        if (storedQ) {
          setQData(JSON.parse(storedQ));
        }
      } catch (e) {
        console.error("Error reading stored question", e);
      }
    }
    setStart(false);

    // Save breadcrumb and course session history
    if (location.state?.breadcrumbTrail?.length) {
      sessionStorage.setItem(
        "quiz_breadcrumb",
        JSON.stringify(location.state.breadcrumbTrail)
      );
      sessionStorage.setItem(
        "std_quiz_breadcrumb_trail",
        JSON.stringify(location.state.breadcrumbTrail)
      );
    }

    if (
      location.state?.selectedCourse !== undefined &&
      location.state?.selectedCourse !== null
    ) {
      sessionStorage.setItem(
        "quiz_course",
        JSON.stringify(location.state.selectedCourse)
      );
      sessionStorage.setItem(
        "std_quiz_selected_course",
        JSON.stringify(location.state.selectedCourse)
      );
    }
  }, [location]);

  useEffect(() => {
    if (quizDataNew) {
      setValue(quizDataNew);
    }

    if (questions?.length > 0) {
      setOldQuestions(questions);
    }

    if (currentQuestion?.question_id && quizData?.id) {
      setQData(currentQuestion);
      sessionStorage.setItem(`currentQuestion_${quizData.id}`, JSON.stringify(currentQuestion));
    }
  }, [quizDataNew, questions, currentQuestion, quizData?.id]);

  useEffect(() => {
    setStdData(startData);
    setStartTime(startData?.started_at);

    const apiSpent = Number(startData?.time_spent);
    if (Number.isFinite(apiSpent) && apiSpent >= 0) {
      apiTimeSpent.current = apiSpent;
    }
  }, [startData]);

  useEffect(() => {
    if (!start) return;
    const { value, fromRemainingTime } = getDisplayDuration(startData, quizData);
    if (value > 0) {
      setDuration(value);
    }

    if (!_.isNull(startTime)) {
    const durationMin = getQuizDurationMinutes(startData, quizData);

    if (fromRemainingTime) {
      if (value > 0) {
        onDurationRun(value);
      }
      return;
    }

    const totalSec = Math.max(0, Math.floor(durationMin * 60));
    const endMs = new Date(startTime).getTime() + totalSec * 1000;
    let diffSec = Math.max(0, moment(endMs).diff(moment(), "seconds"));
    if (diffSec > 0) {
      onDurationRun(diffSec);
    }
    }
  }, [start, startData?.remaining_time, startData?.started_at, startData?.duration, quizData, startTime]);

  useEffect(() => {
    if (start && newDuration <= 0 && seconds <= 0) {
      const attemptData = _.get(value, "attempt_details", null);
      clearInterval(timer.current);
      stdquizComplted({
        quiz_id: quizData?.id,
        attempt: _.get(attemptData, "attempts", ""),
      });
    }
    setMin(newDuration);
  }, [newDuration, seconds, quizData, value, start]);

  const onDurationRun = (totalSecondsIn) => {
    let timeLimitInSeconds = Math.max(
      0,
      Math.floor(Number(totalSecondsIn) || 0)
    );
    clearInterval(timer.current);

    const applyDisplay = () => {
      const minutes = Math.floor(timeLimitInSeconds / 60);
      const seconds = timeLimitInSeconds % 60;
      setNewDuration(minutes);
      setNewSeconds(seconds);
    };

    applyDisplay();

    function startTimer() {
      timeLimitInSeconds -= 1;
      if (timeLimitInSeconds < 0) {
        timeLimitInSeconds = 0;
      }
      applyDisplay();
    }
    timer.current = setInterval(startTimer, 1000);
  };

  const onBackClick = () => {
    onCallQuestion({ qId: value.previous_question_id, quizId: quizData?.id });
  };

  const onComplet = () => {
    const attemptData = _.get(value, "attempt_details", null);

    _.delay(() => {
      stdquizComplted({
        quiz_id: quizData?.id,
        attempt: _.get(attemptData, "attempts", ""),
      });
    }, 1000);
    clearInterval(timer.current);
  };

   // Returns total time spent in seconds
  const getSpendTimeSeconds = () => {
  const previouslySpent = Number(startData?.time_spent ?? apiTimeSpent.current ?? 0);
  const validPreviouslySpent = Number.isFinite(previouslySpent) ? previouslySpent : 0;

  const currentPageSpent = pageStartTime.current
    ? Math.max(0, Math.floor((Date.now() - pageStartTime.current) / 1000))
    : 0;

  return validPreviouslySpent + currentPageSpent;
};

  const onNextClick = (questionData, data) => {
    const attemptData = _.get(value, "attempt_details", null);

    let qId = value?.next_question_id;
    if (_.isNull(qId) || !qId) {
      qId = data?.id;
    }

    const params = {
        attempt: _.get(attemptData, "attempts", ""),
        quiz_id: quizData?.id,
        question_id: data?.id,
        answer: _.get(data, "answer", []),
        is_answered: _.get(data, "isAnswered", 0),
        is_flag: _.get(data, "isFlag", 0),
        time_spent: getSpendTimeSeconds(),
      };

    const nextData = {
      quizId: quizData?.id,
      qId,
      time_spent: getSpendTimeSeconds(),
    };

    stdStudentAnswer(params, nextData)
      .then((response) => {
        const payload = response?.payload ?? response;
        if (payload && payload.status === false) {
          const attempt = _.get(attemptData, "attempts", "");
          return stdquizComplted({ quiz_id: quizData?.id, attempt })
            .catch(() => {})
            .finally(() => {
              navigateToQuizWithBreadcrumb(navigate, location);
            });
        }
      })
      .catch(() => {
        console.error("Error submitting answer", { params });
      });
  };

  const onCallQuestion = ({ quizId, qId }) => {
    getAQuestionOfQuiz({ quizId, qId,time_spent: getSpendTimeSeconds() });
  };
  const isAttemptInProgress = React.useMemo(() => {
    const attempts = Number(quizData?.quiz_status?.[0]?.attempts || 0);
    const isCompleted = quizData?.quiz_status?.[0]?.is_completed === 1;
    return attempts > 0 && !isCompleted;
  }, [quizData]);

  const quizEntryAction = React.useMemo(() => {
    if (quizState?.action === "start") {
      return "start";
    }
    if (quizState?.action === "fetch" || location.state?.resume || isAttemptInProgress) {
      return "fetch"
    }
    return quizState?.action;
  }, [quizState?.action, location.state?.resume, isAttemptInProgress]);

  const onStart = () => {
    pageStartTime.current = Date.now();
    setStart(true);
    if (quizEntryAction === "fetch") {
      const attempt = getResumeAttempt(quizData);
      stdstartQuiz({ quiz_id: quizData.id, attempt: attempt - 1 });
    } else {
    const attempt = getNewStartAttemptIndex(quizData);
    stdstartQuiz({ quiz_id: quizData?.id, attempt });
    }
  };

  const handleTopBackClick = () => {
    navigateToQuizWithBreadcrumb(navigate, location);
  };

  return (
    <>
      <Box className="main-screen-container">
        <Grid container flexDirection={"column"} mt={3}>
          {!start ? (
            <Grid item>
              <IconButtonComponent
                onclick={handleTopBackClick}
                btnType="backbtn"
                btnText="Back"
              />
            </Grid>
          ) : null}
          <Grid item>
            <Grid container flexDirection={"column"}>
              <Grid item>
                <Grid container spacing={2} alignItems="flex-start">
                  {start ? (
                  <>
                    <Grid
                      item
                      xl={2}
                      lg={2}
                      md={2}
                      xs={12}
                      sx={{
                        backgroundColor: {
                          xl: "#ededed",
                          lg: "#ededed",
                          md: "#ededed",
                        },
                        maxHeight: { xl: 800, lg: 700, md: 600, sm: 300 },
                        overflow: "scroll",
                        display: "flex",
                        alignSelf: "flex-start",
                      }}
                      className="custom-scroll-quiz"
                    >
                      <Grid container gap={1} mt={1} mb={1}>
                        {_.map(oldQuestions, (item, index) => {
                          return (
                            <Grid
                              item
                              xl={5}
                              lg={5}
                              md={5}
                              sm={2}
                              xs={2}
                              key={index + 1 + "list"}
                            >
                              <QuestionStatus
                                handleClick={() => {
                                  onCallQuestion({
                                    quizId: quizData?.id,
                                    qId: item?.question_id,
                                  });
                                }}
                                data={_.get(item, "user_answer", {})}
                                question={index + 1}
                              />
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Grid>
                  <Grid
                    item
                    xl={start ? 10 : 12}
                    lg={start ? 10 : 12}
                    md={start ? 10 : 12}
                    xs={12}
                  >
                    <Grid container flexDirection={"column"}>
                      <Grid item>
                        <Box p={2}>
                            <QuizMainCard
                              index={qData?.sequential_number}
                              length={oldQuestions?.length}
                              data={qData || currentQuestion}
                              answers={qData?.user_answer}
                              onBack={onBackClick}
                              onNext={(data) => onNextClick(qData, data)}
                              quizName={quizData?.name}
                              duration={duration}
                              durationFromRemainingTime={shouldUseRemainingTime(startData?.remaining_time)}
                              quizId={quizData?.id}
                              quizWeek={quizData?.week}
                              start={start}
                              min={min}
                              seconds={seconds}
                              time={time}
                              newList={oldQuestions}
                              onComplet={onComplet}
                            />
                        </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12}>
                    <Box p={2}>
                      <QuizFirstCard
                        onQuizStart={onStart}
                        quizEntryAction={quizEntryAction}
                        quizData={quizData}
                      />
                    </Box>
                  </Grid>
                )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default connect(
  (state) => ({
    stdquizList: state.quizes.get("stdquizList"),
    startData: state.quizes.get("startData"),
    completeData: state.quizes.get("completeData"),
    questions: state.quizes.get("questions"),
    studentAnswers: state.quizes.get("studentAnswers"),
    loadingAction: state.common.get("loadingAction"),
    isQuizStarted: state.quizes.get("isQuizStarted"),
    quizDataNew: state.quizes.get("quizDataNew"),
    currentQuestion: state.quizes.get("currentQuestion"),
    quizState: state.quizes.get("quizState"),
  }),
  {
    stdstartQuiz: Actions.quizes.stdstartQuiz,
    stdquizComplted: Actions.quizes.stdquizComplted,
    stdgetQuestions: Actions.quizes.stdgetQuestions,
    stdStudentAnswer: Actions.quizes.stdStudentAnswer,
    updateQuizState: Actions.quizes.updateQuizState,
    quizStateChange: Actions.quizes.quizStateChange,
    getAQuestionOfQuiz: Actions.quizes.getAQuestionOfQuiz,
    getStudentQuizStatus: Actions.quizes.getStudentQuizStatus,
  }
)(QuizMainScreen);
